import { Injectable } from '@angular/core';
import {NodeApiService} from '../../../../services/api/network/online/node/node-api.service';
import {ConnectionApiService} from '../../../../services/api/network/online/connection/connection-api.service';
import {QualityBasedRoutingApiService}
  from '../../../../services/api/settings/routing/quality-based-routing/quality-based-routing-api.service';
import {RoutingInterfaceApiService} from '../../../../services/api/network/online/routing-interface/routing-interface-api.service';
import {LogicalConjunctionService} from '../../../../services/common/logical-conjunction/logical-conjunction.service';
import {DataCacheApiService} from '../../map/data-cache-api/data-cache-api.service';
import {MatDialog} from '@angular/material/dialog';
import {SnackBarService} from '../../../../services/common/snack-bar/snack-bar.service';
import {ConnectionDialogService} from '../../../connections/connections-dialog/connection-dialog.service';
import {forkJoin} from 'rxjs';
import {MapService} from '../../map/map/map.service';

@Injectable({
  providedIn: 'root'
})
export class OnlineConnectionService {

  constructor(private qualityBasedRoutingApiService: QualityBasedRoutingApiService,
              private connectionApiService: ConnectionApiService,
              private nodeApiService: NodeApiService,
              private logicalConjunctionService: LogicalConjunctionService,
              private routingInterfaceApiService: RoutingInterfaceApiService,
              private dataCacheApiService: DataCacheApiService,
              private snackBarService: SnackBarService,
              private connectionDialogService: ConnectionDialogService,
              private mapService: MapService,
              public dialog: MatDialog) {}

  public editConnection(id: number): void {
    forkJoin({
      connection: this.connectionApiService.getConnection(id),
      routingInterfaces: this.routingInterfaceApiService.getRoutingInterfacesForMap(),
      advancedConditions: this.qualityBasedRoutingApiService.getQualityBasedRoutingSettings()
    }).subscribe(({ connection, routingInterfaces, advancedConditions }) => {
      this.connectionDialogService.edit(connection, this.dataCacheApiService.getNodes(),
        routingInterfaces, this.dataCacheApiService.getIpProfiles(),
        this.dataCacheApiService.getMediaRealm(), advancedConditions , () => {
          this.refreshDiagram();
        });
    });
  }

  public addConnection(fromNodeId ?: number, toNodeId ?: number): void {
    const connection = {
      srcNode: fromNodeId,
      destNode: toNodeId
    };
    forkJoin({
      routingInterfaces: this.routingInterfaceApiService.getRoutingInterfacesForMap(),
      advancedConditions: this.qualityBasedRoutingApiService.getQualityBasedRoutingSettings()
    }).subscribe(({ routingInterfaces, advancedConditions }) => {
      this.connectionDialogService.add(connection, this.dataCacheApiService.getNodes(), routingInterfaces,
        this.dataCacheApiService.getIpProfiles(), this.dataCacheApiService.getMediaRealm(),
        advancedConditions, () => {
          this.refreshDiagram();
        }, () => {
          this.refreshDiagram();
        });
    });
  }

  public deleteConnection(connection): void {
    this.connectionDialogService.delete([connection], () => {
      this.refreshDiagram();
    });
  }

  public deleteConnections(connections): void {
    this.connectionDialogService.delete(connections, () => {
      this.refreshDiagram();
    });
  }

  private editConnectionInServer(connection, id: number): void {
    this.connectionApiService.editConnection(connection, id).then(() => {
      // this.sharedEventService.broadcast('closeConnectionDialog');
      this.refreshDiagram();
    }).catch(() => {});
  }

  private addConnectionInServer(connection): void {
    this.connectionApiService.addConnection(connection).then(() => {
      // this.sharedEventService.broadcast('closeConnectionDialog');
      this.refreshDiagram();
    }).catch(() => {});
  }

  private refreshDiagram(): void {
    this.mapService.refresh();
  }
}
